/* 个人中心 */
export default {
  title: "个人信息",
  cooperationType: "合作商类型",
  id: "供应商ID",
  name: "公司名称",
  city: "国家/地区",
  linkman: "联系人姓名",
  phone: "联系人电话",
  verifyText: "已认证",
  email: "联系人邮箱",
  address: "地址",
  other: "其他联系方式",
  settleType: "结算类型",
  signStatus: "签约状态",
  signText: "查看协议 >",
  contractText: "查看合同 >",
  updateText: "修改 >",
  receiveAccountBankNo: "收款银行卡号",

  alterPass: "修改密码",
  alterPassTitle: "修改密码",
  curentPassLabel: "当前密码",
  curentPassPlaceholder: "请输入",
  newPassLabel: "新密码",
  newPassPlaceholder: "请输入字母、数字组合，不少于8位",
  confirmNewPassLabel: "确认新密码",
  confirmNewPassPlaceholder: "请再次输入密码",
  cancelText: "取消",
  comfirmText: '确认提交',

  // 查看协议 
  checkProtocolConfirmText: "同意",
  checkProtocolCancelText: "不同意",

  // 验证手机号弹窗
  verifyPhoneTitle: "请确认您的身份",
  verifyPhoneConfirmText: "下一步",
  verifyPhoneCancelText: "取消",
  verifyPhoneFormPhone: "手机号",
  verifyPhoneFormCode: "短信验证码",
  verifyPhoneFormCodePlaceholder: "请输入验证码",
  verifyPhoneFormSendText: "发送验证码",
  verifyPhoneFormResendText: "重新发送",

  // 录入身份信息弹窗
  enterInfoTitle: "信息录入",
  enterInfoConfirmText: "下一步",
  enterInfoCancelText: "取消",
  enterInfoFormName: "姓名",
  enterInfoFormIdCard: "身份证号",
  enterInfoFormIdCardImg: "身份证图片",

  // 收款信息弹窗
  receiveInfoTitle: "收款信息",
  receiveInfoConfirmText: "下一步",
  receiveInfoCancelText: "取消",
  receiveInfoConfirmSubmitText: "确认提交",
  receiveInfoRewriteText: "重新填写",
  receiveInfoFormBankNo: "银行卡号",
  receiveInfoFormBankName: "开户行",
  receiveInfoFormBankAddress: "开户行地址",
  receiveInfoFormReceiveAccountName: "收款人姓名",
  receiveInfoSubmitConfirmText: "确认提交",
  receiveInfoRewriteCancelText: "重新填写",

  // 下载确认单弹窗
  downloadConfirmTitle: "下载确认件",
  downloadConfirmAgreeText: "同意",
  downloadConfirmDisagreeText: "不同意",
  downloadConfirmDownloadText: "下载文件",
};
